import React from 'react';
import { useStore } from 'effector-react';
import { $sandTable } from '@stores/dataStores';
import {
  SandTableBar,
  SandTableEmpty,
  SandTablePlayer,
  SidebarSandTable,
} from '@modules/sandTable';

function PageSandTables() {
  const sandTables = useStore($sandTable);

  if (!sandTables.length) return <SandTableEmpty />;

  return (
    <div className="mt-15 flex flex-1">
      <div className="mr-10 flex flex-grow flex-col">
        <div className="relative flex flex-grow items-center justify-center overflow-hidden rounded bg-black-#28">
          <SandTablePlayer />
        </div>
        <SandTableBar />
      </div>
      <div className="relative w-250 flex-shrink-0 bg-black">
        <SidebarSandTable />
      </div>
    </div>
  );
}

export default PageSandTables;
